import React, { useState } from "react";
import { useSelector } from "react-redux";
import Page from "../components/Page";
import { useAuthFunctions } from "../hooks/useAuthFunctions";
import LoadingPage from "./LoadingPage";

function SignUpPage() {
  const [selectedRole, setSelectedRole] = useState("Parent");
  const { handleSignup } = useAuthFunctions();

  // Accessing data
  const singleTypeSlug = "sign-up";
  const { data } = useSelector((state) => state.cms);
  const cmsData = data[singleTypeSlug] && data[singleTypeSlug].attributes;
  const { handleSignUp } = useAuthFunctions();

  

  // Only load if data has returned.
  if (!cmsData) return <LoadingPage />;

  return (
    <Page data-wf-page="63509ce3cdf07c2f8f4895c5" data-wf-site="634efd6b20b65bfc05be44e4">
      <div className="section wf-section">
        <div className="container authcontainer w-container">
          <div className="iconbox">
            <img src={cmsData.image.data && cmsData.image.data.attributes.url} loading="lazy" alt="" />
          </div>

          <h1 className="textroyalblue">{cmsData.title}</h1>
          {/* Selecting an option to register as. */}

          <div className="divregisteroption">
            <div id="w-node-_166bad27-a643-323a-07fd-f557fbacbc53-8f4895c5">{cmsData.text}</div>
            <div data-hover="false" data-delay="0" className="w-dropdown">
              <div className="dropdown-toggle w-dropdown-toggle">
                <div>{selectedRole}</div>
              </div>
              <nav className="dropdownlist w-dropdown-list">
                <a href="#" className="dropdownlink w-dropdown-link" onClick={() => setSelectedRole("Cadet")}>
                 Cadet
                </a>
                <a href="#" className="dropdownlink w-dropdown-link" onClick={() => setSelectedRole("Staff")}>
                Staff
                  </a>
                <a href="#" className="dropdownlink w-dropdown-link" onClick={() => setSelectedRole("Parent")}>
                  Parent
                </a>
              </nav>
            </div>
          </div>

          {/* Signup Form */}
          <div className="authformblock w-form">
            <form onSubmit={handleSignup} className="authform">
              <div className="divformnames">
                <input type="text" className="formtextfield fillgainsboro w-input" maxLength={256} name="firstName" placeholder="First Name *" id="signup-first" required="true" />
                <input type="text" className="formtextfield fillgainsboro w-input" maxLength={256} name="lastName" placeholder="Last Name *" id="signup-last" required="true" />
                {selectedRole === "Parent" && (
                  <input type="text" className="formtextfield fillgainsboro w-input" maxLength={256} name="cadetFirstName" placeholder="Cadet First Name" id="signup-cadet-first" />
                )}
                {selectedRole === "Parent" && (
                  <input type="text" className="formtextfield fillgainsboro w-input" maxLength={256} name="cadetLastName" placeholder="Cadet Last Name" id="signup-cadet-last" />
                )}
              </div>
              <input type="email" className="formtextfield fillgainsboro w-input" maxLength={256} name="email" placeholder="Email * " id="signup-email" required="true" />
              <input type="password" className="formtextfield fillgainsboro  w-input" maxLength={256} name="password" placeholder="Password * " id="signup-password" required="true" />
              <input type="text" className="displayHide" name="currentRole" id="signup-role"  value={selectedRole}/>
              <input type="submit" defaultValue="Sign Up" data-wait="Please wait..." className="buttonsubmit w-button" />
            </form>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default SignUpPage;
